// src/app/App.tsx
import '../language/i18n.ts';
import '../common/styles/button-overrides.css';
import '../common/styles/table-overrides.css';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './routing'; // Assuming your router is exported from routing/index.ts


import { useEffect } from 'react';
import { useAuthStore } from '@/features/auth/store/authStore';
import AppProvider from './providers/AppProvider';


function App() {
  const logout = useAuthStore((state) => state.logout);
  const token = useAuthStore((state) => state.token);
  

  useEffect(() => {
    const handleAuthEvent = (payload: { type?: string; timestamp?: number } | null) => {
      if (!payload?.type) return;
      const { type, timestamp } = payload;
      const lastHandled = sessionStorage.getItem('last_insurance_auth_event_ts');
      if (timestamp && lastHandled === String(timestamp)) {
        return;
      }
      if (timestamp) {
        sessionStorage.setItem('last_insurance_auth_event_ts', String(timestamp));
      }
      if (type === 'logout') {
        if (token) {
          logout({ broadcast: false });
        }
        router.navigate({ to: '/auth/login' });
      }
      if (type === 'login') {
        if (!token) {
          window.location.reload();
        }
      }
    };

    const handleStorage = (event: StorageEvent) => {
      if (event.key === 'insurance_auth_event' && event.newValue) {
        try {
          handleAuthEvent(JSON.parse(event.newValue));
        } catch (err) {
          if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn('Failed to parse insurance_auth_event:', err);
          }
        }
      }
    };

    let channel: BroadcastChannel | null = null;
    if ('BroadcastChannel' in window) {
      channel = new BroadcastChannel('auth');
      channel.onmessage = (message) => {
        const data = message?.data as { type?: string; timestamp?: number } | undefined;
        handleAuthEvent(data ?? null);
      };
    }

    window.addEventListener('storage', handleStorage);
    return () => {
      window.removeEventListener('storage', handleStorage);
      channel?.close();
    };
  }, [logout, token]);

  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
}

export default App;